import React from 'react';

type Props = {
  children?: React.ReactNode;
};

interface State {
  error?: Error;
}

export class ErrorBoundary extends React.Component<Props, State> {
  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  constructor(props: Props) {
    super(props);
    this.state = { error: undefined };
  }

  public render() {
    const { error } = this.state;
    return error ? (
      <>
        <p>An error occured with this widget</p>
        <small>
          <div>
            <code>{error.message}</code>
          </div>
          <code>{error.stack}</code>
        </small>
      </>
    ) : (
      <>{this.props.children}</>
    );
  }
}
